var $1ccc8d3c866b7484$exports = {};
const $1ccc8d3c866b7484$var$demoButton = document.getElementById("demo");
if ($1ccc8d3c866b7484$var$demoButton) $1ccc8d3c866b7484$var$demoButton.addEventListener("click", ()=>{
    const script = document.createElement("script");
    script.src = "/index.js";
    document.body.appendChild(script);
});


//# sourceMappingURL=index.722364f4.js.map
